export default function subscribeMutation(store, caseValue, fctToCall, secondFctToCall) {
  const unsubscribe = store.subscribe((mutation) => {
    switch (mutation.type) {
      case caseValue:
        if (fctToCall !== undefined) fctToCall();
        if (secondFctToCall) secondFctToCall();
        break;
      default:
        break;
    }
  });
  return unsubscribe;
}
